import SecretSyncRule from './src/secret-sync-rule';

export default SecretSyncRule;
